module.exports = function(service) {
    'use strict';
    service.factory('countCharacters',countCharacters);
	countCharacters.$inject=['editorExludeShortcode'];
	function countCharacters(editorExludeShortcode) {
            return function(content) {
                if(!content) return 0;
                var cleanContent = editorExludeShortcode(content)
        // Remove HTML tags but keep their content
                    .replace(/<[^>]*>/g, '')
                    // Decode HTML entities
                    .replace(/&nbsp;/g, ' ')
                    .replace(/&amp;/g, '&')
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&quot;/g, '"')
                    // Remove extra whitespace
                    .replace(/\s+/g, ' ')
                    .trim();
                // Create temporary element to decode HTML entities
                var txt = document.createElement("textarea");
                txt.innerHTML = cleanContent;
                // Get decoded text
                var decodedText = txt.value;
                
                return decodedText.length;
            }
    }
};  


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/countCharactersService.js
// module id = 592
// module chunks = 0